import React from 'react';
import { Box, Avatar, Tooltip } from '@mui/material';
import enabledAccount from '@assets/icons/account-enable-icon.svg';
import disabledAccount from '@assets/icons/block-user-icon.svg';

const AccountStatusFormatter = ({ value, lan }) => {
  const isActive = value === 0 || value === 'ENABLED';
  const icon = isActive ? enabledAccount : disabledAccount;
  const title = isActive ? lan.activeAccount : lan.accountDeactivated;

  return (
    <Box
      sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 20, minWidth: 20, }}
    >
      <Tooltip title={title}>
        <Avatar
          src={icon} alt="" variant="square" sx={{ width: 14, height: 14, bgcolor: 'transparent', objectFit: 'contain' }}
        />
      </Tooltip>
    </Box>
  );
};
export default AccountStatusFormatter;
/*class AccountStatusFormatter extends React.Component {
	render() {
		const type = this.props.value;
		const icon = type == 0 ? enabledAccount : disabledAccount;
		const title = type == 0 ? this.props.lan.activeAccount : this.props.lan.accountDeactivated;

		return (
			<div className='row no-padding'>
				<Tooltip title={title}>
					<Image src={icon} alt='' className='SmartTable-icon-image' />
				</Tooltip>
			</div>
		);
	}
}

export default AccountStatusFormatter;*/
